// Date 2020-10-10 11:23:48

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import sithMesPrdPpHeaderEdit from "@/views/sithMes/prd/SithMesPrdPpHeaderEdit.vue";
import sithMesPrdPpHeaderList from "@/views/sithMes/prd/SithMesPrdPpHeaderList.vue";
import sithMesPrdPpOperationList from "@/views/sithMes/prd/SithMesPrdPpOperationList.vue";
import sithMesPrdPpOperationEdit from "@/views/sithMes/prd/SithMesPrdPpOperationEdit.vue";
import sithMesPrdRoutingSummaryEdit from "@/views/sithMes/prd/SithMesPrdRoutingSummaryEdit.vue";
import sithMesPrdRoutingSummaryList from "@/views/sithMes/prd/SithMesPrdRoutingSummaryList.vue";
import sithMesPrdRoutingSummaryDetailEdit from "@/views/sithMes/prd/SithMesPrdRoutingSummaryDetailEdit.vue";
import sithMesPrdRoutingSummaryDetailList from "@/views/sithMes/prd/SithMesPrdRoutingSummaryDetailList.vue";
import sithMesPrdOperationUserEdit from "@/views/sithMes/prd/SithMesPrdOperationUserEdit.vue";
import sithMesPrdOperationUserList from "@/views/sithMes/prd/SithMesPrdOperationUserList.vue";
import sithMesPrdLearningList from "@/views/sithMes/prd/SithMesPrdLearningList.vue";
import sithMesPrdLearningEdit from "@/views/sithMes/prd/SithMesPrdLearningEdit.vue";
import sithMesPrdProjectPlanPrpEdit from "@/views/sithMes/prd/SithMesPrdProjectPlanPrpEdit.vue";
import sithMesPrdProjectPlanPrpList from "@/views/sithMes/prd/SithMesPrdProjectPlanPrpList.vue";
import sithMesPrdProjectPlanDetailPpdEdit from "@/views/sithMes/prd/SithMesPrdProjectPlanDetailPpdEdit.vue";
import sithMesPrdProjectPlanDetailPpdList from "@/views/sithMes/prd/SithMesPrdProjectPlanDetailPpdList.vue";
import sithMesPrdPdsrRPrpPdrpList from "@/views/sithMes/prd/SithMesPrdPdsrRPrpPdrpList.vue";
import sithMesPrdPdsrRPrpPdrpEdit from "@/views/sithMes/prd/SithMesPrdPdsrRPrpPdrpEdit.vue";
import sithMesPrdManBorrowProcessEdit from "@/views/sithMes/prd/SithMesPrdManBorrowProcessEdit";
import sithMesPrdManBorrowProcessList from "@/views/sithMes/prd/SithMesPrdManBorrowProcessList";
import sithMesPrdManBorrowProcessTask from "@/views/sithMes/prd/SithMesPrdManBorrowProcessTask";
import sithMesPrdPpHeaderInfoModifyEdit from "@/views/sithMes/prd/SithMesPrdPpHeaderInfoModifyEdit";
import sithMesPrdPpHeaderInfoModifyList from "@/views/sithMes/prd/SithMesPrdPpHeaderInfoModifyList";
import sithMesPrdSdProjectEdit from "@/views/sithMes/prd/SithMesPrdSdProjectEdit.vue";
import sithMesPrdSdProjectList from "@/views/sithMes/prd/SithMesPrdSdProjectList.vue";
import sithMesPrdSdProjectActivityEdit from "@/views/sithMes/prd/SithMesPrdSdProjectActivityEdit.vue";
import sithMesPrdSdProjectActivityList from "@/views/sithMes/prd/SithMesPrdSdProjectActivityList.vue";
import sithMesPrdSdProjectNetworkEdit from "@/views/sithMes/prd/SithMesPrdSdProjectNetworkEdit.vue";
import sithMesPrdSdProjectNetworkList from "@/views/sithMes/prd/SithMesPrdSdProjectNetworkList.vue";
import sithMesPrdSdProjectWbsEdit from "@/views/sithMes/prd/SithMesPrdSdProjectWbsEdit.vue";
import sithMesPrdSdProjectWbsList from "@/views/sithMes/prd/SithMesPrdSdProjectWbsList.vue";
import sithMesPrdSdProjectWbsHrcEdit from "@/views/sithMes/prd/SithMesPrdSdProjectWbsHrcEdit.vue";
import sithMesPrdSdProjectWbsHrcList from "@/views/sithMes/prd/SithMesPrdSdProjectWbsHrcList.vue";
import sithMesPrdPpNetworkList from "@/views/sithMes/prd/SithMesPrdPpNetworkList.vue";
import sithMesPrdPpNetworkEdit from "@/views/sithMes/prd/SithMesPrdPpNetworkEdit.vue";
import sithMesPrdPpComponentList from "@/views/sithMes/prd/SithMesPrdPpComponentList.vue";
import sithMesPrdPpComponentEdit from "@/views/sithMes/prd/SithMesPrdPpComponentEdit.vue";
import sithMesSapHandleRecordList from "@/views/sithMes/prd/SithMesSapHandleRecordList.vue";
import sithMesSapHandleRecordEdit from "@/views/sithMes/prd/SithMesSapHandleRecordEdit.vue";
import sithMesPrdSapRewriteQueue from "@/views/sithMes/prd/SithMesPrdSapRewriteQueue.vue";
import sithMesPrdProjectInfoList from "@/views/sithMes/prd/SithMesPrdProjectInfoList.vue";
import sithMesPrdProjectInfoEdit from "@/views/sithMes/prd/SithMesPrdProjectInfoEdit.vue";
import sithMesPrdPpHeaderInfoModifyOwnerEdit from "@/views/sithMes/prd/SithMesPrdPpHeaderInfoModifyOwnerEdit.vue";
import sithMesPrdPpHeaderInfoModifyOwnerList from "@/views/sithMes/prd/SithMesPrdPpHeaderInfoModifyOwnerList.vue";
import sithMesPrdPpdScheduledResultItemPsriEdit from "@/views/sithMes/prd/SithMesPrdPpdScheduledResultItemPsriEdit";
import sithMesPrdPpdScheduledResultItemPsriList from "@/views/sithMes/prd/SithMesPrdPpdScheduledResultItemPsriList";
import sithMesPrdToolsInfoList from "@/views/sithMes/prd/SithMesPrdToolsInfoList";
import sithMesPrdToolsInfoEdit from "@/views/sithMes/prd/SithMesPrdToolsInfoEdit";
import sithMesPrdToolsPackageList from "@/views/sithMes/prd/SithMesPrdToolsPackageList";
import sithMesPrdToolsPackageEdit from "@/views/sithMes/prd/SithMesPrdToolsPackageEdit";
import sithMesPrdToolsPackageItemEdit from "@/views/sithMes/prd/SithMesPrdToolsPackageItemEdit";
import sithMesPrdToolsPackageItemList from "@/views/sithMes/prd/SithMesPrdToolsPackageItemList";
import sithMesPrdToolsRelateOperationList from "@/views/sithMes/prd/SithMesPrdToolsRelateOperationList";
import sithMesPrdToolsRelateOperationEdit from "@/views/sithMes/prd/SithMesPrdToolsRelateOperationEdit";
import sithMesPrdProjectKamEdit from "@/views/sithMes/prd/SithMesPrdProjectKamEdit.vue";
import sithMesPrdProjectKamList from "@/views/sithMes/prd/SithMesPrdProjectKamList.vue";
import sithMesPrdRoutingMaintainList from "@/views/sithMes/prd/SithMesPrdRoutingMaintainList.vue";
import sithMesPrdRoutingMaintainEdit from "@/views/sithMes/prd/SithMesPrdRoutingMaintainEdit.vue";
import sithMesPrdRoutingMaintainTask from "@/views/sithMes/prd/SithMesPrdRoutingMaintainTask.vue";
import sithMesPrdKamChangeList from "@/views/sithMes/prd/SithMesPrdKamChangeList.vue";
import sithMesPrdKamChangeEdit from "@/views/sithMes/prd/SithMesPrdKamChangeEdit.vue";
import sithMesPrdKamChangeTask from "@/views/sithMes/prd/SithMesPrdKamChangeTask.vue";
import sithMesPrdProjectPlanPrpENManage from "@/views/sithMes/prd/SithMesPrdProjectPlanPrpENManage";
import sithMesPrdProjectPlanPrpOMManage from "@/views/sithMes/prd/SithMesPrdProjectPlanPrpOMManage";
import sithMesPrdProjectProfitCenterEdit from "@/views/sithMes/prd/SithMesPrdProjectProfitCenterEdit.vue";
import sithMesPrdProjectProfitCenterList from "@/views/sithMes/prd/SithMesPrdProjectProfitCenterList.vue";
import sithMesPrdWorkHourRecordList from "@/views/sithMes/prd/SithMesPrdWorkHourRecordList.vue";
import sithMesPrdZpp1Task from "@/views/sithMes/prd/SithMesPrdZpp1Task.vue";
import sithMesPrdZpp1Edit from "@/views/sithMes/prd/SithMesPrdZpp1Edit.vue";
import sithMesPrdZpp1List from "@/views/sithMes/prd/SithMesPrdZpp1List.vue";
import sithMesPrdZpp2List from "@/views/sithMes/prd/SithMesPrdZpp2List.vue";
import sithMesPrdZpp2Task from "@/views/sithMes/prd/SithMesPrdZpp2Task.vue";
import sithMesPrdZpp2Edit from "@/views/sithMes/prd/SithMesPrdZpp2Edit.vue";
import sithMesPrdFaultRecordList from "@/views/sithMes/prd/SithMesPrdFaultRecordList.vue";
import sithMesPrdZpp2MaterialsDetailList from "@/views/sithMes/prd/SithMesPrdZpp2MaterialsDetailList.vue";
import sithMesPrdZpp2MaterialsDetailEdit from "@/views/sithMes/prd/SithMesPrdZpp2MaterialsDetailEdit.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
    //公用组件注册
    {
        path: "/sithMes/prd/sithMesPrdPpStatus/list",
        name: "sithMesPrdPpStatusList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpStatus/edit",
        name: "sithMesPrdPpStatusEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpStatusUpdateLog/list",
        name: "sithMesPrdPpStatusUpdateLogList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpStatusUpdateLog/edit",
        name: "sithMesPrdPpStatusUpdateLogEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdShiftHandover/list",
        name: "sithMesPrdShiftHandoverList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline, prop_export: route.query.export}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdShiftHandover/edit",
        name: "sithMesPrdShiftHandoverEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdStopWorkType/list",
        name: "sithMesPrdStopWorkTypeList",
        component: emLevelTreeListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdStopWorkType/edit",
        name: "sithMesPrdStopWorkTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdWorkHourRecord/list",
        name: "sithMesPrdWorkHourRecordList",
        component: sithMesPrdWorkHourRecordList,
        props: (route) => ({prop_inline: route.query.inline, prop_export: route.query.export}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdWorkHourRecord/edit",
        name: "sithMesPrdWorkHourRecordEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdEhs/list",
        name: "sithMesPrdEhsList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdEhs/edit",
        name: "sithMesPrdEhsEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectInfo/list",
        name: "sithMesPrdProjectInfoList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectInfo/edit",
        name: "sithMesPrdProjectInfoEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpOperationSchedulePos/list",
        name: "sithMesPrdPpOperationSchedulePosList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpOperationSchedulePos/edit",
        name: "sithMesPrdPpOperationSchedulePosEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpOperationDependencyPod/list",
        name: "sithMesPrdPpOperationDependencyPodList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpOperationDependencyPod/edit",
        name: "sithMesPrdPpOperationDependencyPodEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpScheduledResultPsr/list",
        name: "sithMesPrdPpScheduledResultPsrList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline, prop_export: route.query.export}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpScheduledResultPsr/edit",
        name: "sithMesPrdPpScheduledResultPsrEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdOperationStorage/list",
        name: "sithMesPrdOperationStorageList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdOperationStorage/edit",
        name: "sithMesPrdOperationStorageEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesProProjectPlanDetailDepPpdd/list",
        name: "sithMesProProjectPlanDetailDepPpddList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesProProjectPlanDetailDepPpdd/edit",
        name: "sithMesProProjectPlanDetailDepPpddEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    //自定义页面注册
    {
        path: "/sithMes/prd/sithMesPrdPpHeaderEdit",
        name: "sithMesPrdPpHeaderEdit",
        component: sithMesPrdPpHeaderEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpHeaderList",
        name: "sithMesPrdPpHeaderList",
        component: sithMesPrdPpHeaderList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpOperationList",
        name: "sithMesPrdPpOperationList",
        component: sithMesPrdPpOperationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpOperationEdit",
        name: "sithMesPrdPpOperationEdit",
        component: sithMesPrdPpOperationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdRoutingSummaryEdit",
        name: "sithMesPrdRoutingSummaryEdit",
        component: sithMesPrdRoutingSummaryEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdRoutingSummaryList",
        name: "sithMesPrdRoutingSummaryList",
        component: sithMesPrdRoutingSummaryList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdRoutingSummaryDetailEdit",
        name: "sithMesPrdRoutingSummaryDetailEdit",
        component: sithMesPrdRoutingSummaryDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdRoutingSummaryDetailList",
        name: "sithMesPrdRoutingSummaryDetailList",
        component: sithMesPrdRoutingSummaryDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdOperationUserEdit",
        name: "sithMesPrdOperationUserEdit",
        component: sithMesPrdOperationUserEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdOperationUserList",
        name: "sithMesPrdOperationUserList",
        component: sithMesPrdOperationUserList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdFaultRecordList",
        name: "sithMesPrdFaultRecordList",
        component: sithMesPrdFaultRecordList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdFaultRecord/edit",
        name: "sithMesPrdFaultRecordEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdLearning/list",
        name: "sithMesPrdLearningList",
        component: sithMesPrdLearningList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdLearning/edit",
        name: "sithMesPrdLearningEdit",
        component: sithMesPrdLearningEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectPlanPrpEdit",
        name: "sithMesPrdProjectPlanPrpEdit",
        component: sithMesPrdProjectPlanPrpEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectPlanPrpList",
        name: "sithMesPrdProjectPlanPrpList",
        component: sithMesPrdProjectPlanPrpList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectPlanPrpENManage",
        name: "sithMesPrdProjectPlanPrpENManage",
        component: sithMesPrdProjectPlanPrpENManage,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectPlanPrpOMManage",
        name: "sithMesPrdProjectPlanPrpOMManage",
        component: sithMesPrdProjectPlanPrpOMManage,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectPlanDetailPpdEdit",
        name: "sithMesPrdProjectPlanDetailPpdEdit",
        component: sithMesPrdProjectPlanDetailPpdEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectPlanDetailPpdList",
        name: "sithMesPrdProjectPlanDetailPpdList",
        component: sithMesPrdProjectPlanDetailPpdList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPdsrRPrpPdrpList",
        name: "sithMesPrdPdsrRPrpPdrpList",
        component: sithMesPrdPdsrRPrpPdrpList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPdsrRPrpPdrpEdit",
        name: "sithMesPrdPdsrRPrpPdrpEdit",
        component: sithMesPrdPdsrRPrpPdrpEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdManBorrowProcessEdit",
        name: "sithMesPrdManBorrowProcessEdit",
        component: sithMesPrdManBorrowProcessEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdManBorrowProcessList",
        name: "sithMesPrdManBorrowProcessList",
        component: sithMesPrdManBorrowProcessList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdManBorrowProcessTask",
        name: "sithMesPrdManBorrowProcessTask",
        component: sithMesPrdManBorrowProcessTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpHeaderInfoModifyType/list",
        name: "sithMesPrdPpHeaderInfoModifyTypeList",
        component: emLevelTreeListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpHeaderInfoModifyType/edit",
        name: "sithMesPrdPpHeaderInfoModifyTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpHeaderInfoModifyEdit",
        name: "sithMesPrdPpHeaderInfoModifyEdit",
        component: sithMesPrdPpHeaderInfoModifyEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpHeaderInfoModifyList",
        name: "sithMesPrdPpHeaderInfoModifyList",
        component: sithMesPrdPpHeaderInfoModifyList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectEdit",
        name: "sithMesPrdSdProjectEdit",
        component: sithMesPrdSdProjectEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectList",
        name: "sithMesPrdSdProjectList",
        component: sithMesPrdSdProjectList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectActivityEdit",
        name: "sithMesPrdSdProjectActivityEdit",
        component: sithMesPrdSdProjectActivityEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectActivityList",
        name: "sithMesPrdSdProjectActivityList",
        component: sithMesPrdSdProjectActivityList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectNetworkEdit",
        name: "sithMesPrdSdProjectNetworkEdit",
        component: sithMesPrdSdProjectNetworkEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectNetworkList",
        name: "sithMesPrdSdProjectNetworkList",
        component: sithMesPrdSdProjectNetworkList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectWbsEdit",
        name: "sithMesPrdSdProjectWbsEdit",
        component: sithMesPrdSdProjectWbsEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectWbsList",
        name: "sithMesPrdSdProjectWbsList",
        component: sithMesPrdSdProjectWbsList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectWbsHrcEdit",
        name: "sithMesPrdSdProjectWbsHrcEdit",
        component: sithMesPrdSdProjectWbsHrcEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSdProjectWbsHrcList",
        name: "sithMesPrdSdProjectWbsHrcList",
        component: sithMesPrdSdProjectWbsHrcList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpNetworkList",
        name: "sithMesPrdPpNetworkList",
        component: sithMesPrdPpNetworkList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpNetworkEdit",
        name: "sithMesPrdPpNetworkEdit",
        component: sithMesPrdPpNetworkEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpComponentList",
        name: "sithMesPrdPpComponentList",
        component: sithMesPrdPpComponentList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpComponentEdit",
        name: "sithMesPrdPpComponentEdit",
        component: sithMesPrdPpComponentEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesSapHandleRecordList",
        name: "sithMesSapHandleRecordList",
        component: sithMesSapHandleRecordList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdSapRewriteQueue",
        name: "sithMesPrdSapRewriteQueue",
        component: sithMesPrdSapRewriteQueue,
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesSapHandleRecordEdit",
        name: "sithMesSapHandleRecordEdit",
        component: sithMesSapHandleRecordEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectInfoList",
        name: "sithMesPrdProjectInfoList",
        component: sithMesPrdProjectInfoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectInfoEdit",
        name: "sithMesPrdProjectInfoEdit",
        component: sithMesPrdProjectInfoEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpHeaderInfoModifyOwnerEdit",
        name: "sithMesPrdPpHeaderInfoModifyOwnerEdit",
        component: sithMesPrdPpHeaderInfoModifyOwnerEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpHeaderInfoModifyOwnerList",
        name: "sithMesPrdPpHeaderInfoModifyOwnerList",
        component: sithMesPrdPpHeaderInfoModifyOwnerList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpdScheduledResultItemPsriEdit",
        name: "sithMesPrdPpdScheduledResultItemPsriEdit",
        component: sithMesPrdPpdScheduledResultItemPsriEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdPpdScheduledResultItemPsriList",
        name: "sithMesPrdPpdScheduledResultItemPsriList",
        component: sithMesPrdPpdScheduledResultItemPsriList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdToolsInfoList",
        name: "sithMesPrdToolsInfoList",
        component: sithMesPrdToolsInfoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdToolsInfoEdit",
        name: "sithMesPrdToolsInfoEdit",
        component: sithMesPrdToolsInfoEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdToolsPackageList",
        name: "sithMesPrdToolsPackageList",
        component: sithMesPrdToolsPackageList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdToolsPackageEdit",
        name: "sithMesPrdToolsPackageEdit",
        component: sithMesPrdToolsPackageEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdToolsPackageItemEdit",
        name: "sithMesPrdToolsPackageItemEdit",
        component: sithMesPrdToolsPackageItemEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdToolsPackageItemList",
        name: "sithMesPrdToolsPackageItemList",
        component: sithMesPrdToolsPackageItemList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdToolsRelateOperationList",
        name: "sithMesPrdToolsRelateOperationList",
        component: sithMesPrdToolsRelateOperationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdToolsRelateOperationEdit",
        name: "sithMesPrdToolsRelateOperationEdit",
        component: sithMesPrdToolsRelateOperationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectKamEdit",
        name: "sithMesPrdProjectKamEdit",
        component: sithMesPrdProjectKamEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectKamList",
        name: "sithMesPrdProjectKamList",
        component: sithMesPrdProjectKamList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdRoutingMaintainList",
        name: "sithMesPrdRoutingMaintainList",
        component: sithMesPrdRoutingMaintainList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdRoutingMaintainEdit",
        name: "sithMesPrdRoutingMaintainEdit",
        component: sithMesPrdRoutingMaintainEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdRoutingMaintainTask",
        name: "sithMesPrdRoutingMaintainTask",
        component: sithMesPrdRoutingMaintainTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdKamChangeList",
        name: "sithMesPrdKamChangeList",
        component: sithMesPrdKamChangeList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdKamChangeEdit",
        name: "sithMesPrdKamChangeEdit",
        component: sithMesPrdKamChangeEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdKamChangeTask",
        name: "sithMesPrdKamChangeTask",
        component: sithMesPrdKamChangeTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    //自定义页面注册
    {
        path: "/sithMes/prd/sithMesPrdProjectProfitCenterEdit",
        name: "sithMesPrdProjectProfitCenterEdit",
        component: sithMesPrdProjectProfitCenterEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdProjectProfitCenterList",
        name: "sithMesPrdProjectProfitCenterList",
        component: sithMesPrdProjectProfitCenterList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdZpp1Task",
        name: "sithMesPrdZpp1Task",
        component: sithMesPrdZpp1Task,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdZpp1Edit",
        name: "sithMesPrdZpp1Edit",
        component: sithMesPrdZpp1Edit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdZpp1List",
        name: "sithMesPrdZpp1List",
        component: sithMesPrdZpp1List,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdZpp2List",
        name: "sithMesPrdZpp2List",
        component: sithMesPrdZpp2List,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdZpp2Task",
        name: "sithMesPrdZpp2Task",
        component: sithMesPrdZpp2Task,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdZpp2Edit",
        name: "sithMesPrdZpp2Edit",
        component: sithMesPrdZpp2Edit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdZpp2MaterialsDetailList",
        name: "sithMesPrdZpp2MaterialsDetailList",
        component: sithMesPrdZpp2MaterialsDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/prd/sithMesPrdZpp2MaterialsDetailEdit",
        name: "sithMesPrdZpp2MaterialsDetailEdit",
        component: sithMesPrdZpp2MaterialsDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]
